import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: [
    'DV_DP_TAB_episodes',
    'DV_DP_TAB_explore',
    'DV_DP_TAB_extras',
    'DV_DP_TAB_related',
    'DV_DP_TAB_details',
  ] as const,
}
